var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNounHighlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m800.52 455.04c9.4805-9.3594 9.6016-24.48 0.23828-33.961-9.3594-9.4805-24.48-9.4805-33.961-0.23828l-186 183.24c-9.4805 9.3594-9.6016 24.48-0.23828 33.961 4.6797 4.8008 10.922 7.1992 17.039 7.1992 6.1211 0 12.121-2.2812 16.801-6.9609l186-183.24z",
    fill: "#ff001b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m806.16 746.16h-176.52c-13.199 0-24 10.801-24 24 0 13.199 10.801 24 24 24h176.52c13.199 0 24-10.801 24-24 0-13.199-10.801-24-24-24z",
    fill: "#ff001b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m441.84 381.84c-13.199 0-24 10.801-24 24v176.52c0 13.199 10.801 24 24 24 13.199 0 24-10.801 24-24v-176.52c0-13.199-10.801-24-24-24z",
    fill: "#ff001b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounHighlight);
export default __webpack_public_path__ + "static/media/noun-highlight.1653eb60267399782cffcad43ce2c40f.svg";
export { ForwardRef as ReactComponent };